/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getClinicalDictionaryTypes } from 'app/entities/clinical-dictionary-type/clinical-dictionary-type.reducer';
import { getEntities as getClinicalDictionaries } from 'app/entities/clinical-dictionary/clinical-dictionary.reducer';
import { getEntities as getLabTestItems } from 'app/entities/lab-test-item/lab-test-item.reducer';
import { getEntities as getDiagLabs } from 'app/entities/diag-lab/diag-lab.reducer';
import { getEntities as getDiagLabPanels } from 'app/entities/diag-lab-panel/diag-lab-panel.reducer';
import { createEntity, getEntity, reset, updateEntity } from './lab-test-item-attribute.reducer';

export const LabTestItemAttributeUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const clinicalDictionaryTypes = useAppSelector(state => state.clinicalDictionaryType.entities);
  const clinicalDictionaries = useAppSelector(state => state.clinicalDictionary.entities);
  const labTestItems = useAppSelector(state => state.labTestItem.entities);
  const diagLabs = useAppSelector(state => state.diagLab.entities);
  const diagLabPanels = useAppSelector(state => state.diagLabPanel.entities);
  const labTestItemAttributeEntity = useAppSelector(state => state.labTestItemAttribute.entity);
  const loading = useAppSelector(state => state.labTestItemAttribute.loading);
  const updating = useAppSelector(state => state.labTestItemAttribute.updating);
  const updateSuccess = useAppSelector(state => state.labTestItemAttribute.updateSuccess);

  const handleClose = () => {
    navigate(`/lab-test-item-attribute${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getClinicalDictionaryTypes({}));
    dispatch(getClinicalDictionaries({}));
    dispatch(getLabTestItems({}));
    dispatch(getDiagLabs({}));
    dispatch(getDiagLabPanels({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...labTestItemAttributeEntity,
      ...values,
      attributeType: clinicalDictionaryTypes.find(it => it.id.toString() === values.attributeType?.toString()),
      attribute: clinicalDictionaries.find(it => it.id.toString() === values.attribute?.toString()),
      testItem: labTestItems.find(it => it.id.toString() === values.testItem?.toString()),
      diagLab: diagLabs.find(it => it.id.toString() === values.diagLab?.toString()),
      panel: diagLabPanels.find(it => it.id.toString() === values.panel?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...labTestItemAttributeEntity,
          attributeType: labTestItemAttributeEntity?.attributeType?.id,
          attribute: labTestItemAttributeEntity?.attribute?.id,
          testItem: labTestItemAttributeEntity?.testItem?.id,
          diagLab: labTestItemAttributeEntity?.diagLab?.id,
          panel: labTestItemAttributeEntity?.panel?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.labTestItemAttribute.home.createOrEditLabel" data-cy="LabTestItemAttributeCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.labTestItemAttribute.home.createOrEditLabel">
              Create or edit a LabTestItemAttribute
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="lab-test-item-attribute-id"
                  label={translate('tinyMedicRestApp.labTestItemAttribute.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItemAttribute.name')}
                id="lab-test-item-attribute-name"
                name="name"
                data-cy="name"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItemAttribute.value')}
                id="lab-test-item-attribute-value"
                name="value"
                data-cy="value"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItemAttribute.active')}
                id="lab-test-item-attribute-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItemAttribute.cursor')}
                id="lab-test-item-attribute-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItemAttribute.lastUpdated')}
                id="lab-test-item-attribute-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItemAttribute.microSec')}
                id="lab-test-item-attribute-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItemAttribute.timestampEntry')}
                id="lab-test-item-attribute-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="lab-test-item-attribute-attributeType"
                name="attributeType"
                data-cy="attributeType"
                label={translate('tinyMedicRestApp.labTestItemAttribute.attributeType')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaryTypes
                  ? clinicalDictionaryTypes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="lab-test-item-attribute-attribute"
                name="attribute"
                data-cy="attribute"
                label={translate('tinyMedicRestApp.labTestItemAttribute.attribute')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="lab-test-item-attribute-testItem"
                name="testItem"
                data-cy="testItem"
                label={translate('tinyMedicRestApp.labTestItemAttribute.testItem')}
                type="select"
              >
                <option value="" key="0" />
                {labTestItems
                  ? labTestItems.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="lab-test-item-attribute-diagLab"
                name="diagLab"
                data-cy="diagLab"
                label={translate('tinyMedicRestApp.labTestItemAttribute.diagLab')}
                type="select"
              >
                <option value="" key="0" />
                {diagLabs
                  ? diagLabs.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="lab-test-item-attribute-panel"
                name="panel"
                data-cy="panel"
                label={translate('tinyMedicRestApp.labTestItemAttribute.panel')}
                type="select"
              >
                <option value="" key="0" />
                {diagLabPanels
                  ? diagLabPanels.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/lab-test-item-attribute" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default LabTestItemAttributeUpdate;
